import React from 'react';
import { Button } from './ui/button';

const Hero = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="hero-section relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Dark background with subtle texture */}
      <div className="absolute inset-0 bg-black">
        <div className="absolute inset-0 opacity-10 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZGVmcz48cGF0dGVybiBpZD0iZ3JpZCIgd2lkdGg9IjQwIiBoZWlnaHQ9IjQwIiBwYXR0ZXJuVW5pdHM9InVzZXJTcGFjZU9uVXNlIj48cGF0aCBkPSJNIDQwIDAgTCAwIDAgMCA0MCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIxIi8+PC9wYXR0ZXJuPjwvZGVmcz48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSJ1cmwoI2dyaWQpIi8+PC9zdmc+')]"></div>
      </div>

      {/* Red glow effects */}
      <div className="absolute top-1/4 -left-32 w-96 h-96 bg-red-600 rounded-full opacity-20 blur-3xl"></div>
      <div className="absolute bottom-1/4 -right-32 w-96 h-96 bg-red-600 rounded-full opacity-20 blur-3xl"></div>

      {/* Content */}
      <div className="relative z-10 max-w-6xl mx-auto px-6 py-20 text-center">
        <div className="flex justify-center items-center mb-8 animate-fade-in">
          <img
            src="https://customer-assets.emergentagent.com/job_design-ink-12/artifacts/1pnctvsn_tagline%20wht%20logo.png"
            alt="Tagline Tattoo Studio Logo"
            className="w-80 md:w-96 lg:w-[500px] h-auto" />

        </div>
        
        <h1 className="hero-title font-black uppercase animate-slide-up !font-['Comic_Sans_MS'] !text-3xl mb-6 text-white">Tagline Tattoo Studio

        </h1>
        
        <p className="hero-subtitle text-2xl md:text-3xl text-red-500 font-bold mb-4 tracking-wider uppercase animate-slide-up-delay-1">
          Where Art Meets Skin
        </p>
        
        <p className="text-lg md:text-xl text-gray-400 max-w-2xl mx-auto mb-12 animate-slide-up-delay-2">Experience the finest tattoo artistry in the city. Our  artists bring your vision to life with precision and passion.

        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center animate-slide-up-delay-3">
          <Button
            onClick={() => scrollToSection('booking')}
            className="bg-red-600 hover:bg-red-700 text-white px-8 py-6 text-lg font-bold uppercase tracking-wider transition-all duration-300 transform hover:scale-105 hover:shadow-xl hover:shadow-red-600/50">

            Book Now
          </Button>
          <Button
            onClick={() => scrollToSection('gallery')}
            variant="outline"
            className="border-2 border-red-600 text-red-600 hover:bg-red-600 hover:text-white px-8 py-6 text-lg font-bold uppercase tracking-wider transition-all duration-300 transform hover:scale-105">

            View Gallery
          </Button>
        </div>

        {/* Scroll indicator */}
        <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 animate-bounce">
          <div className="w-6 h-10 border-2 border-red-600 rounded-full flex justify-center">
            <div className="w-1 h-3 bg-red-600 rounded-full mt-2 animate-pulse"></div>
          </div>
        </div>
      </div>
    </section>);

};

export default Hero;